import React, { useState } from 'react';
import { Card, CardBody, CardHeader, Col } from 'reactstrap';
import { Btn, H5, ToolTip } from '../../../../AbstractElements';
import { HTMLElements } from '../../../../Constant/index';
import HtmlContentTooltip from './HtmlContentTooltip';

const HtmlElement = () => {
  const [tooltip, setTooltip] = useState(false);
  const toggle = () => setTooltip(!tooltip);
  const tooltips = <>{'Tooltip'} <b>with</b> <code>HTML</code></>;
  const Data = [
    {
      id: 6,
      placement: 'right',
      btntext: 'Click me',
      tooltip: tooltips
    },
    {
      id: 7,
      placement: 'bottom',
      btntext: 'Click me',
      tooltip: tooltips
    },
    {
      id: 8,
      placement: 'left',
      btntext: 'Click me',
      tooltip: tooltips
    }
  ];
  return (
    <Col sm="12">
      <Card>
        <CardHeader className='pb-0'>
          <H5>{HTMLElements}</H5>
        </CardHeader>
        <CardBody className="btn-showcase">
          <Btn attrBtn={{ color: 'primary', id: 'Tooltip-5', onClick: toggle }}>Click me</Btn>
          <ToolTip
            attrToolTip={{
              placement: 'top',
              isOpen: tooltip,
              target: 'Tooltip-5',
            }} >
            {tooltips}
          </ToolTip>
          {Data.map((item, i) =>
            <HtmlContentTooltip key={i} item={item} />
          )}
        </CardBody>
      </Card>
    </Col>
  );
};

export default HtmlElement;